module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA7ElEQVRYR+2TQQ6CMBBFZwgxqVbhKNxAexLlZHITOAJHAa02MYQxsFIjZVpj2LTrSf/Ly/8ICz9cOB8CQDAQDPxkwOjLaZixkLvCd87eAMZcD9D35RgcRUqIbeUD4QXw0DrroCsRMR1CiaiJIVYrKWtXCGcAIkrNvS0RMHsNI6BarBOFiI0LhDOA0U0FiPuvIUSVkKn6G4C5tUPZjjMBhdgkOReCbWBsPNKZ9TFhzl0GC+Ct8SwC/jJmAT4bz83nLsMKMNV4NgRjGVYAa+PZFPZlTAIwG8/FmFzGbAe4Cb53ASAYCAaCgWBgcQNPboVdIb0+ZmoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/三角形.png
// module id = 2pQg
// module chunks = 0